import { call } from "../helpers/axiosInterceptor";

const getEvents = async () => {
  try {
    const { data } = await call.get(`event/read`,
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("refToken"),
        }
      },);
    return data;
  } catch (e) {

    return [];
  }
};

const createEvent = async (data: any) => {
  try {
    const res = await call.post("event/", { data },
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("refToken"),
        }
      },);
  } catch (e) {

  }
};

const updateEvent = async (data: any) => {
  try {
    const res = await call.put("event/", { data },
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("refToken"),
        }
      },);
  } catch (e) {

  }
};

const deleteEvent = async (id: string) => {
  try {
    const res = await call.delete(`event/delete/${id}`,
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("refToken"),
        }
      },);
    return res;
  } catch (e) {

    throw e;
  }
};

const getEventRegisteredStudents = async (eventId: string) => {
  try {
    
    const { data } = await call.get(`user/event-students/${eventId}?includeAttendance=true`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("refToken"),
      }
    });
    return data;
  } catch (e) {

    return [];
  }
};

const updateEventStudentAttendance = async (eventId: string, studentId: string, attended: boolean) => {
  try {
    const { data } = await call.post(
      `user/event-attendance`, 
      { eventId, studentId, attended },
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("refToken"),
        }
      }
    );
    return data;
  } catch (e) {
    
    throw e;
  }
};

export { getEvents, createEvent, updateEvent, deleteEvent, getEventRegisteredStudents, updateEventStudentAttendance };
